import httpHelper from "@/helpers/httpHelper";

const CONTROLLER = "/Auth/User";
const userApi = {
    ClearCache(data) {
        return httpHelper.get("auth/test/ClearCache", data);
    },
    SignIn(data) {
        return httpHelper.post(CONTROLLER + "/SignIn", data);
    },
    Profile() {
        return httpHelper.get(CONTROLLER + "/Profile");
    },
    EditProfile(data) {
        return httpHelper.put(CONTROLLER + "/EditProfile", data);
    },
    Users(data) {
        return httpHelper.get(CONTROLLER + "/Users", data);
    },
    Signout() {
        return httpHelper.get(CONTROLLER + "/Signout");
    },
    LogInFromAccessToken(data) {
        return httpHelper.post(CONTROLLER + "/LogInFromAccessToken", data);
    },
    GetUsers(data) {
        return httpHelper.post(CONTROLLER + "/GetUsers", data);
    },
    ChangeUserType(data) {
      return httpHelper.get(CONTROLLER + "/ChangeUserType", data);
    }
}

export default userApi;
